import { render, staticRenderFns } from "./PageReportDept.vue?vue&type=template&id=c6595870&"
import script from "./PageReportDept.vue?vue&type=script&lang=js&"
export * from "./PageReportDept.vue?vue&type=script&lang=js&"
import style0 from "./PageReportDept.vue?vue&type=style&index=0&id=c6595870&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports